import React from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import LoadingView from '../../../components/LoadingView/LoadingView.js'; // your custom loader     
function AddRecommendation(props) {
    const [loading, setLoading] = React.useState(false);    
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'recommendedItem', headerName: 'Recommended Item', width: 200 },
        { field: 'Timeduration', headerName: 'Time Duration', width: 200 }
    ];

    const dataRows = [
        { id: 1, checkbox: '', recommendedItem: 'Chicken cheese burger', Timeduration: "10:00 AM-10:00 PM" },
        { id: 2, checkbox: '', recommendedItem: 'Chicken Pizza', Timeduration: "10:00 AM-10:00 PM" },
    ];
    React.useEffect(() => {
        setLoading(true); // show loading
        const timer = setTimeout(() => setLoading(false), 1000); // hide after 1s
        return () => clearTimeout(timer);
    }, []);
    return (
        <div>
            <LoadingView open={loading} close={() => setLoading(false)} />
            <div>
                <FilterComponents title={"OK"} isItem={5} />
                <CustomDataGrid columns={columns} dataRows={dataRows} />
            </div>
        </div>
    );
}

export default AddRecommendation;